import type { QueryClient } from "@tanstack/react-query";
import { parseScheduledDropEnrollmentsFromWidgetData } from "@/lib/dashboard/scheduled-drop-enrollments-widget";
import { SCHEDULED_DROP_WIDGET_REFRESH_MS } from "@/lib/dashboard/scheduled-drop-widget-constants";
import { fetchWidgetDataBatched } from "@/lib/dashboard/widgets-client";
import { QueryKeys } from "@/lib/types";
import { DashboardWidgetId } from "@/lib/types/dashboard-widgets";
import { resolveEffectiveTenantNumber } from "@/lib/utils/env/effective-tenant";

export async function prefetchScheduledDropEnrollmentsWidget(
  queryClient: QueryClient,
  accessToken: string,
) {
  const tenantId = resolveEffectiveTenantNumber();

  await queryClient.prefetchQuery({
    queryKey: [
      QueryKeys.WidgetData,
      tenantId,
      DashboardWidgetId.ScheduledDropEnrollments,
    ],
    queryFn: async () => {
      const items = await fetchWidgetDataBatched(accessToken, tenantId, [
        DashboardWidgetId.ScheduledDropEnrollments,
      ]);
      return parseScheduledDropEnrollmentsFromWidgetData(items);
    },
    staleTime: SCHEDULED_DROP_WIDGET_REFRESH_MS,
  });

  return queryClient;
}
